import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-petition-approval-grid',
  templateUrl: './petition-approval-grid.component.html',
  styleUrls: ['./petition-approval-grid.component.css']
})
export class PetitionApprovalGridComponent implements OnInit {

  title="Petition List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/petition/petition-approval-grid/petition-approval-grid.component.ts